// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Vista detail di una singola risorsa ======
// Mostra tutti i clienti suddivisi tra "con accesso" e "senza accesso".
// Edit inline di stato, ruoli (lista, autocomplete dal catalogo) e note.
// Ricerca live, tooltip storico inline, export PDF.

globalThis.currentRisorsaDetail = null;

const STATES_WITH_ACCESS = ['Sì', 'Si', 'Richieste', 'Da richiedere', 'Da eliminare'];

function risorsaHasAccess(stato) {
  if (!stato) return false;
  return STATES_WITH_ACCESS.includes(stato);
}

// Stato filtri della vista (search e mostra-modificati-only)
let _rdFilter = { search: '', onlyDirty: false };

async function openRisorsaDetail(nome) {
  const ok = typeof confirmIfDirty === 'function' ? await confirmIfDirty() : true;
  if (!ok) return;
  globalThis.currentRisorsaDetail = nome;
  _rdFilter = { search: '', onlyDirty: false };
  await setView('risorsa-detail');
}

function backToRisorse() {
  globalThis.currentRisorsaDetail = null;
  setView('risorse');
}

function ruoliFromInput(value) {
  if (!value) return [];
  const arr = value
    .split(/[,;\n]/)
    .map((s) => s.trim())
    .filter(Boolean);
  return [...new Set(arr)];
}

function ruoliPillsHtml(ruoli) {
  if (!ruoli || !ruoli.length) return '<span class="muted">—</span>';
  return ruoli.map((r) => `<span class="role-chip">${escapeHtml(r)}</span>`).join(' ');
}

// ====== Storico inline (tooltip su riga) ======
function metaTooltip(meta) {
  if (!meta || (!meta.modifiedAt && !meta.modifiedByName)) return '';
  const parts = [];
  if (meta.modifiedAt) parts.push('Mod: ' + fmtDateTime(meta.modifiedAt));
  if (meta.modifiedByName) parts.push('Da: ' + meta.modifiedByName);
  return parts.join('\n');
}

// ====== Render principale ======
function renderRisorsaDetail() {
  if (!globalThis.currentRisorsaDetail) {
    setView('risorse');
    return;
  }
  const nome = globalThis.currentRisorsaDetail;
  const titleEl = document.getElementById('risorsaDetailTitle');
  if (titleEl) titleEl.textContent = nome;

  const conAccesso = [];
  const senzaAccesso = [];

  state.clients.forEach((c) => {
    const stato = (c.accessi && c.accessi[nome]) || '';
    const meta = (c.accessiMeta && c.accessiMeta[nome]) || { ruoli: [], note: '' };
    const row = { cliente: c, stato, ruoli: meta.ruoli || [], note: meta.note || '', meta };
    if (risorsaHasAccess(stato)) conAccesso.push(row);
    else senzaAccesso.push(row);
  });

  conAccesso.sort((a, b) => a.cliente.nome.localeCompare(b.cliente.nome));
  senzaAccesso.sort((a, b) => a.cliente.nome.localeCompare(b.cliente.nome));

  // Filtro search live
  const s = (_rdFilter.search || '').toLowerCase().trim();
  const matchSearch = (row) => {
    if (!s) return true;
    return (
      row.cliente.nome.toLowerCase().includes(s) ||
      (row.cliente.cpl || '').toLowerCase().includes(s) ||
      (row.ruoli || []).join(' ').toLowerCase().includes(s) ||
      (row.note || '').toLowerCase().includes(s)
    );
  };
  const filteredCon = conAccesso.filter(matchSearch);
  const filteredSenza = senzaAccesso.filter(matchSearch);

  // KPI
  if (document.getElementById('rdKpiConAccesso'))
    document.getElementById('rdKpiConAccesso').textContent = conAccesso.length;
  if (document.getElementById('rdKpiSenzaAccesso'))
    document.getElementById('rdKpiSenzaAccesso').textContent = senzaAccesso.length;
  if (document.getElementById('rdKpiTotale'))
    document.getElementById('rdKpiTotale').textContent = state.clients.length;

  // Datalist autocomplete ruoli (catalogo + custom usati)
  const dl = document.getElementById('ruoliDatalist');
  if (dl) {
    const ruoli = typeof allKnownRuoli === 'function' ? allKnownRuoli() : [];
    dl.innerHTML = ruoli.map((r) => `<option value="${escapeHtml(r)}">`).join('');
  }

  document.getElementById('tbodyRdConAccesso').innerHTML = renderRowsHtml(filteredCon, true);
  document.getElementById('tbodyRdSenzaAccesso').innerHTML = renderRowsHtml(filteredSenza, false);

  bindRowsEvents(nome);
  registerRdDirtyGuard(nome);
}

function renderRowsHtml(rows, conAccesso) {
  if (!rows.length) {
    return `<tr><td colspan="5" style="text-align:center;padding:24px;color:var(--text-muted)">${
      conAccesso
        ? 'Nessun cliente con accesso o in gestione.'
        : 'Nessun cliente in questa categoria.'
    }</td></tr>`;
  }
  return rows
    .map((r) => {
      const opts = STATUS_OPTIONS.map(
        (s) => `<option value="${s}" ${s === r.stato ? 'selected' : ''}>${s || '—'}</option>`
      ).join('');
      const ruoliInput = (r.ruoli || []).join(', ');
      const tip = metaTooltip(r.meta);
      return `
      <tr data-cliente="${escapeHtml(r.cliente.nome)}" ${tip ? `title="${escapeHtml(tip)}"` : ''}>
        <td>
          <div class="rd-cli">
            <strong>${escapeHtml(r.cliente.nome)}</strong>
            ${r.cliente.cpl ? `<div class="muted" style="font-size:11px;">CPL: ${escapeHtml(r.cliente.cpl)}</div>` : ''}
            ${r.meta?.modifiedAt ? `<div class="muted" style="font-size:10px;">Aggiornato ${fmtDateTime(r.meta.modifiedAt)}${r.meta.modifiedByName ? ' da ' + escapeHtml(r.meta.modifiedByName) : ''}</div>` : ''}
          </div>
        </td>
        <td><select class="rd-stato" data-field="stato">${opts}</select></td>
        <td>
          <input class="rd-ruoli" type="text" data-field="ruoli" list="ruoliDatalist"
                 value="${escapeHtml(ruoliInput)}"
                 placeholder="Es. Global Admin, Subscription Owner">
          <div class="rd-ruoli-preview" style="margin-top:4px;">${ruoliPillsHtml(r.ruoli)}</div>
        </td>
        <td>
          <textarea class="rd-note" data-field="note" rows="2"
                    placeholder="Annotazioni libere">${escapeHtml(r.note || '')}</textarea>
        </td>
        <td>
          <button class="btn btn-sm btn-primary rd-save" data-act="save" disabled>Salva</button>
          <button class="btn btn-sm rd-open" data-act="open-cliente">Apri</button>
        </td>
      </tr>`;
    })
    .join('');
}

function bindRowsEvents(risorsaNome) {
  document
    .querySelectorAll('#tbodyRdConAccesso tr[data-cliente], #tbodyRdSenzaAccesso tr[data-cliente]')
    .forEach((tr) => {
      const saveBtn = tr.querySelector('.rd-save');
      const ruoliInput = tr.querySelector('.rd-ruoli');
      const previewEl = tr.querySelector('.rd-ruoli-preview');

      tr.querySelectorAll('[data-field]').forEach((input) => {
        input.addEventListener('input', () => {
          saveBtn.disabled = false;
          tr.classList.add('rd-dirty');
        });
        input.addEventListener('change', () => {
          saveBtn.disabled = false;
          tr.classList.add('rd-dirty');
        });
      });

      if (ruoliInput && previewEl) {
        ruoliInput.addEventListener('input', () => {
          const ruoli = ruoliFromInput(ruoliInput.value);
          previewEl.innerHTML = ruoliPillsHtml(ruoli);
        });
      }

      saveBtn.addEventListener('click', async () => {
        const clienteName = tr.dataset.cliente;
        const stato = tr.querySelector('[data-field="stato"]').value;
        const ruoli = ruoliFromInput(tr.querySelector('[data-field="ruoli"]').value);
        const note = tr.querySelector('[data-field="note"]').value;
        saveBtn.disabled = true;
        saveBtn.textContent = 'Salvataggio…';
        try {
          const cli = state.clients.find((c) => c.nome === clienteName);
          const oldStato = cli?.accessi?.[risorsaNome] || '';
          const oldRuoli = cli?.accessiMeta?.[risorsaNome]?.ruoli || [];
          const oldNote = cli?.accessiMeta?.[risorsaNome]?.note || '';
          await api.updateAccesso(clienteName, risorsaNome, { stato, ruoli, note });
          const changes = [];
          if (oldStato !== stato)
            changes.push({ field: 'Stato accesso', from: oldStato, to: stato });
          if (oldRuoli.join(', ') !== ruoli.join(', '))
            changes.push({ field: 'Ruoli', from: oldRuoli.join(', '), to: ruoli.join(', ') });
          if (oldNote !== note) changes.push({ field: 'Note', from: oldNote, to: note });
          if (changes.length) {
            logAudit({
              action: 'update',
              entity: 'Accesso',
              target: `${clienteName} · ${risorsaNome}`,
              changes
            });
          }
          await refreshClient(clienteName);
          tr.classList.remove('rd-dirty');
          renderRisorsaDetail();
          toast('Accesso aggiornato');
        } catch (e) {
          console.error(e);
          toast('Errore salvataggio: ' + (e.message || e));
          saveBtn.disabled = false;
          saveBtn.textContent = 'Salva';
        }
      });

      tr.querySelector('.rd-open').addEventListener('click', () =>
        openModal(tr.dataset.cliente, 'accessi')
      );
    });
}

// ====== Dirty guard per la vista (almeno una riga ha modifiche pendenti) ======
function hasDirtyRows() {
  // Una riga e' "dirty" se il pulsante salva e' abilitato (= utente ha modificato qualcosa)
  return !!document.querySelector('#view-risorsa-detail .rd-save:not(:disabled)');
}

function registerRdDirtyGuard(nome) {
  if (typeof registerDirtyGuard === 'function') {
    registerDirtyGuard(
      'view-risorsa-detail',
      () =>
        !document.getElementById('view-risorsa-detail').classList.contains('hidden') &&
        hasDirtyRows(),
      `Detail risorsa "${nome}"`
    );
  }
}

// ====== Export PDF scheda risorsa ======
async function exportRisorsaPDF(nome) {
  nome = nome || globalThis.currentRisorsaDetail;
  if (!nome) {
    toast('Nessuna risorsa selezionata');
    return;
  }
  let jsPDF;
  try {
    const mod = await import('jspdf');
    jsPDF = mod.jsPDF || mod.default;
  } catch (e) {
    console.error(e);
    toast('Libreria jsPDF non disponibile');
    return;
  }

  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 40;
  let y = M;

  function ensureSpace(n) {
    if (y + n > H - M) {
      doc.addPage();
      y = M;
    }
  }
  function h1(t) {
    ensureSpace(28);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(26, 34, 56);
    doc.text(t, M, y);
    y += 22;
  }
  function h2(t) {
    ensureSpace(20);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setTextColor(37, 99, 235);
    doc.text(t, M, y);
    y += 16;
  }
  function kv(label, value) {
    ensureSpace(14);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(107, 115, 144);
    doc.text(label, M, y);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(26, 34, 56);
    const wrapped = doc.splitTextToSize(String(value || '—'), W - M - 150);
    doc.text(wrapped, M + 130, y);
    y += Math.max(12, wrapped.length * 12);
  }
  function row(cliente, stato, ruoli, note) {
    ensureSpace(36);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(26, 34, 56);
    doc.text(cliente, M, y);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(107, 115, 144);
    doc.text(`[${stato || '—'}]`, M + 280, y);
    y += 12;
    if (ruoli && ruoli.length) {
      doc.setTextColor(37, 99, 235);
      doc.setFontSize(8);
      const txt = doc.splitTextToSize('Ruoli: ' + ruoli.join(', '), W - M * 2);
      doc.text(txt, M, y);
      y += txt.length * 10;
    }
    if (note) {
      doc.setTextColor(107, 115, 144);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'italic');
      const txt = doc.splitTextToSize('Note: ' + note, W - M * 2);
      doc.text(txt, M, y);
      y += txt.length * 10;
      doc.setFont('helvetica', 'normal');
    }
    y += 4;
    doc.setDrawColor(230);
    doc.line(M, y, W - M, y);
    y += 8;
  }

  // Header
  doc.setFillColor(37, 99, 235);
  doc.rect(M, y, 32, 32, 'F');
  doc.setTextColor(255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.text('MS', M + 8, y + 22);
  doc.setTextColor(26, 34, 56);
  doc.setFontSize(14);
  doc.text('Portale Ma.Se. - Scheda risorsa', M + 44, y + 14);
  doc.setFontSize(9);
  doc.setTextColor(107, 115, 144);
  doc.text(`Esportato il ${new Date().toLocaleString('it-IT')}`, M + 44, y + 28);
  y += 50;
  doc.setDrawColor(220);
  doc.line(M, y, W - M, y);
  y += 14;

  h1(nome);

  // Riepilogo
  const conAccesso = [],
    senzaAccesso = [];
  state.clients.forEach((c) => {
    const stato = (c.accessi && c.accessi[nome]) || '';
    const meta = (c.accessiMeta && c.accessiMeta[nome]) || { ruoli: [], note: '' };
    const r = {
      cliente: c.nome,
      cpl: c.cpl || '',
      stato,
      ruoli: meta.ruoli || [],
      note: meta.note || ''
    };
    if (risorsaHasAccess(stato)) conAccesso.push(r);
    else senzaAccesso.push(r);
  });
  conAccesso.sort((a, b) => a.cliente.localeCompare(b.cliente));
  senzaAccesso.sort((a, b) => a.cliente.localeCompare(b.cliente));

  kv('Clienti con accesso o in gestione', String(conAccesso.length));
  kv('Clienti senza accesso', String(senzaAccesso.length));
  kv('Totale clienti', String(state.clients.length));

  // Sezione 1
  y += 8;
  h2('Clienti con accesso o in gestione');
  if (!conAccesso.length) {
    ensureSpace(14);
    doc.setTextColor(107, 115, 144);
    doc.setFontSize(10);
    doc.text('Nessuno.', M, y);
    y += 12;
  }
  conAccesso.forEach((r) => row(r.cliente, r.stato, r.ruoli, r.note));

  // Sezione 2 (compatta: solo nome + stato, senza ruoli/note se vuoti)
  y += 8;
  h2('Clienti senza accesso');
  if (!senzaAccesso.length) {
    ensureSpace(14);
    doc.setTextColor(107, 115, 144);
    doc.setFontSize(10);
    doc.text('Nessuno.', M, y);
    y += 12;
  }
  senzaAccesso.forEach((r) => row(r.cliente, r.stato, r.ruoli, r.note));

  // Footer
  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(107, 115, 144);
    doc.text(`Portale Ma.Se. - Agic Technology - Riservato`, M, H - 18);
    doc.text(`Pagina ${i}/${pageCount}`, W - M - 60, H - 18);
  }

  const fileName = `risorsa-${nome.replace(/[^a-zA-Z0-9_-]/g, '_').slice(0, 50)}-${new Date().toISOString().slice(0, 10)}.pdf`;
  doc.save(fileName);
  toast('PDF generato');
}

// ====== Event listeners ======
document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('searchRdClienti')?.addEventListener('input', (e) => {
    _rdFilter.search = e.target.value;
    renderRisorsaDetail();
  });
  document.getElementById('btnRdExportPdf')?.addEventListener('click', () => exportRisorsaPDF());
});

Object.assign(globalThis, {
  openRisorsaDetail,
  backToRisorse,
  renderRisorsaDetail,
  exportRisorsaPDF,
  ruoliFromInput,
  hasDirtyRows
});
export {};
